module.exports = __webpack_public_path__ + "static/foodstandslide-06-min-39ce918f823b7363ce3018ac413696f7.jpg";